// ---------------------------------------------------------------------------
// Test Mode — configurable task statuses (CLE-DASH).
//
// Mirrors the 6 statuses seeded by the backend migration (same names, slugs,
// colors, categories and order) so the simulated dataset behaves exactly like
// a freshly-migrated real instance.
// ---------------------------------------------------------------------------

import type { TaskStatusDef } from '../lib/taskStatusesApi';

export const TEST_TASK_STATUSES: TaskStatusDef[] = [
  {
    id: 'ts-backlog',
    name: 'Backlog',
    slug: 'backlog',
    color: '#94a3b8',
    order: 0,
    category: 'BACKLOG',
    isDefault: false,
    taskCount: 0,
  },
  {
    id: 'ts-todo',
    name: 'De făcut',
    slug: 'todo',
    color: '#94a3b8',
    order: 1,
    category: 'UNSTARTED',
    isDefault: true,
    taskCount: 0,
  },
  {
    id: 'ts-in-progress',
    name: 'În lucru',
    slug: 'in_progress',
    color: '#eab308',
    order: 2,
    category: 'STARTED',
    isDefault: false,
    taskCount: 0,
  },
  {
    id: 'ts-in-review',
    name: 'În review',
    slug: 'in_review',
    color: '#22c55e',
    order: 3,
    category: 'STARTED',
    isDefault: false,
    taskCount: 0,
  },
  {
    id: 'ts-done',
    name: 'Finalizat',
    slug: 'done',
    color: '#8b5cf6',
    order: 4,
    category: 'COMPLETED',
    isDefault: false,
    taskCount: 0,
  },
  {
    id: 'ts-cancelled',
    name: 'Anulat',
    slug: 'cancelled',
    color: '#6b7280',
    order: 5,
    category: 'CANCELLED',
    isDefault: false,
    taskCount: 0,
  },
];

export const TEST_STATUS_BY_SLUG: Record<string, TaskStatusDef> = Object.fromEntries(
  TEST_TASK_STATUSES.map((s) => [s.slug, s]),
);

/** Statuses with per-status task counts filled in (GET /api/task-statuses). */
export function buildTaskStatuses(taskStatuses: string[]): TaskStatusDef[] {
  const counts = new Map<string, number>();
  for (const slug of taskStatuses) counts.set(slug, (counts.get(slug) ?? 0) + 1);
  return TEST_TASK_STATUSES.map((s) => ({ ...s, taskCount: counts.get(s.slug) ?? 0 }));
}
